module.exports = __webpack_public_path__ + "img/vue_logo.38cf6745.svg";